import React from 'react';

import { ProductsType } from '../../../../../BatchTicket/components/DynamicAsset/constants';
import { ProductButtonProps } from '../../../../../BatchTicket/components/DynamicButton';

import { ClubsButton } from './products/Clubs';
import { CoesButton } from './products/Coes';
import { DirectTreasuryButton } from './products/DirectTreasury';
import { EquityButton } from './products/Equity';
import { FixedIncomeButton } from './products/FixedIncome';
import { FundsButton } from './products/Funds';
import { PrivatePensionButton } from './products/PrivatePension';
import { PublicOfferButton } from './products/PublicOffer';

export const DynamicButton: React.FC<ProductButtonProps<ProductsType>> = (props) => {
  switch (props.id) {
    case 'fixedIncome':
      return <FixedIncomeButton {...(props as ProductButtonProps<'fixedIncome'>)} />;

    case 'funds':
      return <FundsButton {...(props as ProductButtonProps<'funds'>)} />;

    case 'directTreasury':
      return <DirectTreasuryButton {...(props as ProductButtonProps<'directTreasury'>)} />;

    case 'equity':
      return <EquityButton {...(props as ProductButtonProps<'equity'>)} />;

    case 'coes':
      return <CoesButton {...(props as ProductButtonProps<'coes'>)} />;

    case 'publicOffers':
      return <PublicOfferButton {...(props as ProductButtonProps<'publicOffers'>)} />;

    case 'clubs':
      return <ClubsButton {...(props as ProductButtonProps<'clubs'>)} />;

    case 'privatePension':
      return <PrivatePensionButton {...(props as ProductButtonProps<'privatePension'>)} />;

    default:
      return null;
  }
};
